angular.module("bccNgApp").controller('DoctorSearchController', ["$scope", function ($scope) {

    $scope.specialties = [];
    $scope.cancers = [];
    $scope.selectedSpecialty = [];
    $scope.selectedCancers = [];
    $scope.distance = 0;
    $scope.results = [];
    $scope.address = "";
    $scope.lat = 0;
    $scope.lng = 0;
    $scope.loading = false;
    $scope.resultCount = 0;
    $scope.sort = "AZ";
    $scope.sortString = "A - Z";
    $scope.page = 1;
    $scope.pages = [];
    $scope.showMobile = false;

    $scope.init = function () {
        getResults();
    }

    $scope.updateSpecialty = function (e, specialty) {
        if (e) {
            e.preventDefault();
        }
        $(".doctor-specialties .dropdown-toggle").dropdown('hide');
        $scope.selectedSpecialty = specialty;
        updateQuerystring("s", specialty);
        getResults();
    }

    $scope.toggleCancer = function (e, cancer) {
        if (e) {
            e.preventDefault();
        }
        var idx = $scope.selectedCancers.indexOf(cancer);
        if (idx > -1) {
            $scope.selectedCancers.splice(idx, 1);
        } else {
            $scope.selectedCancers.push(cancer);
        }
        updateQuerystring("ct", $scope.selectedCancers.join(";"));
        getResults();
    }

    $scope.searchAddressKeyDown = function (e) {
        if (e.key === "Enter") {
            $scope.searchAddress();
        }
    }

    $scope.searchAddress = function () {
        geoCode({ address: $scope.address }, function (result) {
            updateLocation(result);
        });
    }

    $scope.currentLocation = function (e) {
        e.preventDefault();
        getLocation(function (coords) {
            geoCode({ location: coords }, function (result) {
                updateLocation(result);
            });
        });
    }

    $scope.clearSpecialties = function (e) {
        e.preventDefault();
        $scope.selectedSpecialty = "";
        updateQuerystring("s", "");
        getResults();
    }

    $scope.clearCancers = function (e) {
        e.preventDefault();
        $scope.selectedCancers = [];
        updateQuerystring("ct", "");
        getResults();
    }

    $scope.clearLocation = function (e) {
        e.preventDefault();
        $scope.address = "";
        $scope.lat = 0;
        $scope.lng = 0;
        getResults();
    }

    $scope.clearAll = function (e) {
        e.preventDefault();
        $scope.selectedSpecialty = "";
        $scope.selectedCancers = [];
        $scope.address = "";
        $scope.lat = 0;
        $scope.lng = 0;
        getResults();
    }

    $scope.updateSort = function (e, sort, sortString) {
        if (e) {
            e.preventDefault();
        }
        $scope.sort = sort;
        $scope.sortString = sortString;
        getResults();
    }

    $scope.changePage = function (e, page) {
        e.preventDefault();
        if (page <= $scope.pages.length && page > 0) {
            $scope.page = page;
            updateQuerystring("p", page);
            $([document.documentElement, document.body]).animate({
                scrollTop: $(".sort-count").offset().top
            }, 250);
            getResults(false);
        }
    }

    $scope.toggleMobileFilters = function (e) {
        e.preventDefault();
        $scope.showMobile = !$scope.showMobile;
    }

    function updateLocation(result) {
        if (result) {
            $scope.address = result.address;
            $scope.lat = result.lat;
            $scope.lng = result.lng;
            $scope.sort = "DT";
            $scope.sortString = "Distance";
            $scope.$apply();
        }
        getResults();
    }

    function getResults(resetPage = true) {
        if (resetPage) {
            $scope.page = 1;
        }
        $scope.loading = true;
        var url = buildUrl();
        $.get(url, function (data) {
            $scope.specialties = data.Facets.specialties;
            $scope.cancers = data.Facets.bcc_cancer_types;
            $scope.results = data.Results;
            $scope.resultCount = data.ResultCount;
            $scope.loading = false;
            var pages = Math.ceil(data.ResultCount / data.Criteria.PageSize);
            $scope.pages = [];
            for (var i = 1; i <= pages; i++) {
                $scope.pages.push(i);
            }
            $scope.$apply();
        }).fail(function () {
            alert("A search error occurred.");
        });
    }

    function buildUrl() {
        var url = "/api/sitecore/BccDoctors/Api";
        url += "?d=" + $scope.distance;
        url += "&lt=" + $scope.lat;
        url += "&ln=" + $scope.lng;
        url += "&so=" + $scope.sort;
        url += "&p=" + $scope.page;

        var urlParams = new URLSearchParams(window.location.search);
        var query = urlParams.get('q');
        if (query && query.length > 0) {
            url = url + "&q=" + query;
        }

        if ($scope.selectedSpecialty.length > 0) {
            url += "&s=" + $scope.selectedSpecialty;
        }
        if ($scope.selectedCancers.length > 0) {
            url += "&ct=" + $scope.selectedCancers.join(";");
        }

        return url;
    }

    function geoCode(query, callback) {
        var geocoder = new google.maps.Geocoder();
        geocoder.geocode(query, function (results, status) {
            if (status == google.maps.GeocoderStatus.OK && results && results.length > 0) {
                var data = results[0];
                callback({
                    address: data.formatted_address,
                    lat: data.geometry.location.lat(),
                    lng: data.geometry.location.lng()
                });
            } else {
                return null;
            }
        });
    }

    function getLocation(callback) {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition((position) => {
                if (position && position.coords) {
                    callback({
                        lat: position.coords.latitude,
                        lng: position.coords.longitude
                    });
                }
            });
        }
    }

    function updateQuerystring(key, value) {
        if ("URLSearchParams" in window) {
            var searchParams = new URLSearchParams(window.location.search);
            searchParams.set(key, value);
            var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?' + searchParams.toString();
            window.history.pushState({ path: newurl }, '', newurl);
            $("form.bcc-search-form").each(function () {
                var input = $(this).find("input[name='" + key + "']");
                if (input.length > 0) {
                    input.attr("value", value);
                } else {value
                    $(this).append('<input type="hidden" name="' + key + '" value="' + value + '" />')
                }
            });
        }
    }

}]);


// Prevent dropdown menus from closing when checkboxes are clicked.
/*
$(document).on('click', '.doctor-specialties .dropdown-menu', function (e) {
    e.stopPropagation();
});
*/
$(document).on('click', '.doctor-cancers .dropdown-menu', function (e) {
    e.stopPropagation();
});
